import React from 'react'
import CarrerHeader from './CarrerHeader'
import Footer from './Footer'
import VerificationBanner from './VerificationBanner'

const CarrerLayout = (props) => {
  return (
    <>
      
      <CarrerHeader />
      <VerificationBanner />
      <section className="user-dashboard user-new-dash">
        <div className="container">

          {props.children}
        </div>
      </section>

      <Footer /></>
  )
}

export default CarrerLayout;
